import React from 'react';

export function H1({ children, className = "", ...props }) {
  return (
    <h1 className={`text-4xl font-bold text-textPrimary ${className}`} {...props}>
      {children}
    </h1>
  );
}

export function H2({ children, className = "", ...props }) {
  return (
    <h2 className={`text-3xl font-semibold text-textPrimary ${className}`} {...props}>
      {children}
    </h2>
  );
}

export function H3({ children, className = "", ...props }) {
  return (
    <h3 className={`text-xl font-semibold text-textPrimary ${className}`} {...props}>
      {children}
    </h3>
  );
}

export function H4({ children, className = "", ...props }) {
  return (
    <h4 className={`text-lg font-medium text-textPrimary ${className}`} {...props}>
      {children}
    </h4>
  );
}

export function H6({ children, className = "", ...props }) {
  return (
    <h6 className={`text-base font-medium text-textPrimary ${className}`} {...props}>
      {children}
    </h6>
  );
}

export function Body1({ children, className = "", ...props }) {
  return (
    <p className={`text-base text-textPrimary ${className}`} {...props}>
      {children}
    </p>
  );
}

export function Body2({ children, className = "", ...props }) {
  return (
    <p className={`text-sm text-textSecondary ${className}`} {...props}>
      {children}
    </p>
  );
}

export function Caption({ children, className = "", ...props }) {
  return (
    <span className={`text-xs text-textSecondary ${className}`} {...props}>
      {children}
    </span>
  );
} 